import React, { Component } from "react";

import {CSSTransition} from 'react-transition-group';

import './App.scss';

class PoemTitle extends Component {
    constructor(props) {
        super(props)

        this.state = {showTitle: true}
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {
        clearTimeout(this.hideTimeout)
        setTimeout(() => {
            this.setState({showTitle: true})
            this.hideTimeout = setTimeout(() => {
                this.setState({showTitle: false})
            }, 1000)
        }, 10)
    }

    render() {
        return (
            <CSSTransition
                in={this.state.showTitle}
                timeout={3000}
                classNames="poemtitleTransition"
                unmountOnExit
            >
                <div className="poemtitle">{this.props.title}</div>
            </CSSTransition>
        );
    }
}

export default PoemTitle;
